import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, useLocation, createSearchParams } from "react-router-dom";
import { getSeriesApiCall, getPublicVideoApiCall } from "@/services/api"
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store/index';
import { setSeries } from '@/store/slices/video/seriesSlice';
import { setVideo } from '@/store/slices/video/videoSlice';
import { setScreenWidth } from '@/store/slices/common/screenWidthSlice';
import { maxScreenWidthForDesktop } from "@/pages/watch/main/constants"
import { Toaster } from 'sonner';
import { dummyVideoObj } from "./dummyData"

import WatchMainView from './view'
import { useAuthToken } from "@/hooks/useAppSelectors";
import { handleUpdateUserPurchaseContentApiCall, handleUpdateWelcomeSeriesContentApiCall } from "@/utils/apiUtils";
import Footer from "@/components/common/footer";
import FloatingSupportButtons from "@/components/common/floatingSupportButtons";
import { allPaths } from "@/constants/urlPaths";

export default function WatchMain() {
    const dispatch = useDispatch();
    const location = useLocation();

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isSubscribedSeries = searchParams.get("subscription") === "true";
    const seriesDetails = useSelector((state: RootState) => state.seriesReducer.series);
    const screenWidth = useSelector((state: RootState) => state.screenWidthReducer.screenWidth);
    // const token = useSelector((state: RootState) => state.tokenReducer.token);
    const token = useAuthToken();
    const [isHydrated, setIsHydrated] = useState(false);
    const [isLoading, setIsLoading] = useState(true)
    const [videoChangingId, setVideoChangingId] = useState("")

    const [seriesId, setSeriesId] = useState(searchParams.get("series"));
    const [videoId, setVideoId] = useState(searchParams.get("video"));
    const [isWelcomeSeries, setIsWelcomeSeries] = useState(searchParams.get("ws") === "true");

    const openVideoDirectly = location.state?.openVideoDirectly;
    const isPGCourseSeries = Boolean((seriesDetails?.[0] as { isPGCourseSeries?: boolean } | undefined)?.isPGCourseSeries);


    /*
    currentVideoObj will be used for video dis componete
    and videoDetails redux is created with same data as currentVideoObj for video player, to avoid multi render of video player
    */
    // const [currentVideoObj, setCurrentVideoObj] = useState(dummyVideoObj)
    const [currentVideoObj, setCurrentVideoObj] = useState({})
    const [seriesNotes, setSeriesNotes] = useState<any[]>([])
    /** Avoid reusing Redux series when the same `seriesId` is fetched as course vs subscription (different API header). */
    const lastSeriesFetchKeyRef = useRef<string | null>(null)

    useEffect(() => {
        return () => {
            //@ts-ignore
            dispatch(setVideo(null))
        }
    }, [])


    useEffect(() => {
        videoInit()
    }, [seriesId, videoId, isSubscribedSeries]);


    useEffect(() => {
        setIsHydrated(true)
        dispatch(setScreenWidth(window.innerWidth));
        const handleResize = () => {
            dispatch(setScreenWidth(window.innerWidth));
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, []);



    useEffect(() => {
        // console.log("UP  : ", seriesDetails)
        updateCurrentVideoObj02()
    }, [seriesDetails, videoId])


    // to update currentVideoObj which is used by VideoDis and generally to handle like and dislike update
    const updateCurrentVideoObj02 = () => {
        const eff = videoId && String(videoId).trim() ? videoId : null
        const currentVideoObj_ = resolveVideoFromSeriesData(seriesDetails, eff)
        if (currentVideoObj_) {
            setCurrentVideoObj(currentVideoObj_.videoObj)
        }
    }

    const videoInit = () => {
        // debugger
        if (seriesId) {
            getSeriesHelper(seriesId, videoId ?? "")
        } else if (videoId) {
            getPublicVideo(videoId)
        } else {
            console.log('query param didn;t matched')
            navigate(allPaths.dashboard)
        }
    }


    const getPublicVideo = async (videoDocId: string) => {
        if (token) {
            const paylaod = {
                "purchaseId": null
            }
            const handleUpdateUserPurchaseContentApiCallStatus = await handleUpdateUserPurchaseContentApiCall(paylaod)
            const handleUpdateWelcomeSeriesContentApiCallStatus = await handleUpdateWelcomeSeriesContentApiCall(paylaod)
            if (!handleUpdateUserPurchaseContentApiCallStatus) {
                // Exit if user is login and this api call fails
                return
            }
        }



        const payload = {
            videoDocId: videoDocId
        }
        const getPublicVideoApiCallStatus = await getPublicVideoApiCall(payload)
        if (getPublicVideoApiCallStatus.status) {
            setSeriesNotes([])
            // first time when page opes so to update currentVideoObj
            setCurrentVideoObj(getPublicVideoApiCallStatus.data)
            dispatch(setVideo(getPublicVideoApiCallStatus.data))
            setIsLoading(false)
        } else {
            alert("It is not a public video")
            //@ts-ignore
            // window.location.href = process.env.REACT_APP_USER_PANEL_URL
            navigate(allPaths.dashboard)
        }

    }

    const getSeriesHelper = async (seriesId: string, videoId: string) => {
        getSeries(seriesId, videoId)
        const paylaod = {
            "purchaseId": null
        }
        setTimeout(async () => {
            const handleUpdateUserPurchaseContentApiCallStatus = await handleUpdateUserPurchaseContentApiCall(paylaod)
        }, 2000);
    }



    const getSeries = async (seriesId: string, videoId: string) => {
        let userThisSeriesData = seriesDetails
        let seriesCallReq = true
        const fetchKey = `${seriesId}:${isSubscribedSeries ? "sub" : "course"}`
        if (userThisSeriesData.length > 0) {
            // console.log(userThisSeriesData[0].seriesId, "userThisSeriesData[0].seriesId")
            // console.log(seriesId, "seriesId")
            if (userThisSeriesData[0].seriesId
                && userThisSeriesData[0].seriesId === seriesId
                && lastSeriesFetchKeyRef.current === fetchKey) {
                seriesCallReq = false
                postGetSeriesWork(userThisSeriesData)
            }
        }
        // console.log(seriesCallReq, "seriesCallReq")
        if (seriesCallReq) {
            const getSeriesApiCallStatus = await getSeriesApiCall(seriesId, isWelcomeSeries, isSubscribedSeries);
            if (getSeriesApiCallStatus.status) {
                const sn = getSeriesApiCallStatus.seriesNotes ?? []
                setSeriesNotes(sn)
                dispatch(setSeries(getSeriesApiCallStatus.data))
                lastSeriesFetchKeyRef.current = fetchKey
                postGetSeriesWork(getSeriesApiCallStatus.data)
            } else {
                console.log("Issue in getSeriesApiCall ")
            }
        }
    }



    const postGetSeriesWork = (seriesDetailsArg: any) => {
        const effectiveTarget =
            videoId && String(videoId).trim() ? String(videoId).trim() : null
        const currentVideoObj_ = resolveVideoFromSeriesData(
            seriesDetailsArg,
            effectiveTarget
        )
        if (currentVideoObj_) {
            const chosenId = currentVideoObj_.videoObj._id
            if (!effectiveTarget || effectiveTarget !== chosenId) {
                setVideoId(chosenId)
                navigate(
                    {
                        pathname: location.pathname,
                        search: createSearchParams({
                            series: String(seriesId),
                            video: chosenId,
                            ...(isWelcomeSeries ? { ws: "true" } : {}),
                            ...(isSubscribedSeries ? { subscription: "true" } : {}),
                        }).toString(),
                    },
                    { replace: true, state: location.state }
                )
            }
            setCurrentVideoObj(currentVideoObj_.videoObj)

            /*
                Only update when :
                1. In desktok as on mobile the first screen is series screen
                OR
                2. When we get openVideoDirectly, we get this : openVideoDirectly while coming from history page
                */
            if (openVideoDirectly || window.innerWidth > maxScreenWidthForDesktop) {
                dispatch(setVideo(currentVideoObj_.videoObj))
            }
        }

        setIsLoading(false)

        setVideoChangingId("")
    }






    const getSeries_v2 = async (seriesId: string, videoId: string) => {
        let userThisSeriesData = seriesDetails
        console.log("userThisSeriesData", userThisSeriesData)
        // debugger
        if (userThisSeriesData && userThisSeriesData.length === 0) {
            const getSeriesApiCallStatus = await getSeriesApiCall(seriesId, isWelcomeSeries, isSubscribedSeries);
            if (getSeriesApiCallStatus.status) {
                const sn = getSeriesApiCallStatus.seriesNotes ?? []
                setSeriesNotes(sn)
                userThisSeriesData = getSeriesApiCallStatus.data
                dispatch(setSeries(getSeriesApiCallStatus.data))
            } else {
                console.log("Issue in getSeriesApiCall ")
            }
        }
        if (userThisSeriesData.length > 0) {
            const currentVideoObj_ = findVideoById(userThisSeriesData, videoId)
            if (currentVideoObj_) {
                setCurrentVideoObj(currentVideoObj_.videoObj)

                /*
                    Only update when :
                    1. In desktok as on mobile the first screen is series screen
                    OR
                    2. When we get openVideoDirectly, we get this : openVideoDirectly while coming from history page
                    */
                if (openVideoDirectly || window.innerWidth > maxScreenWidthForDesktop) {
                    dispatch(setVideo(currentVideoObj_.videoObj))
                }
                // 2. OR when in mobile and video is public
                // else if (token === null) {
                //     dispatch(setVideo(currentVideoObj_.videoObj))
                // }
            }
            // console.log("currentVideoObj ", currentVideoObj)

            // dispatch(setSeries(userThisSeriesData))
            setIsLoading(false)

            setVideoChangingId("")
            // console.log(getSeriesApiCallStatus)
        }
    }


    // remove whenever you see it next time...
    const getSeries_v1 = async (seriesId: string, videoId: string) => {
        const getSeriesApiCallStatus = await getSeriesApiCall(seriesId, isWelcomeSeries, isSubscribedSeries);
        if (getSeriesApiCallStatus.status) {
            const sn = getSeriesApiCallStatus.seriesNotes ?? []
            setSeriesNotes(sn)
            const currentVideoObj_ = findVideoById(getSeriesApiCallStatus.data, videoId)
            if (currentVideoObj_) {
                setCurrentVideoObj(currentVideoObj_.videoObj)

                /*
                    Only update when :
                    1. In desktok as on mobile the first screen is series screen
                    OR
                    2. When we get openVideoDirectly, we get this : openVideoDirectly while coming from history page
                    */
                if (openVideoDirectly || window.innerWidth > maxScreenWidthForDesktop) {
                    dispatch(setVideo(currentVideoObj_.videoObj))
                }
                // 2. OR when in mobile and video is public
                // else if (token === null) {
                //     dispatch(setVideo(currentVideoObj_.videoObj))
                // }
            }
            // console.log("currentVideoObj ", currentVideoObj)
            dispatch(setSeries(getSeriesApiCallStatus.data))
            setIsLoading(false)

            setVideoChangingId("")
            // console.log(getSeriesApiCallStatus)
        } else {
            console.log("Issue in getSeriesApiCall ")
        }
    }


    const updateCurrentVideoObj_v1 = (videoDocId: string) => {
        const p = new URLSearchParams()
        if (seriesId) p.set("series", seriesId)
        p.set("video", videoDocId)
        if (isWelcomeSeries) p.set("ws", "true")
        if (isSubscribedSeries) p.set("subscription", "true")
        navigate({ pathname: location.pathname, search: p.toString() }, { state: location.state })
        setVideoId(videoDocId)

        const currentVideoObj_ = findVideoById(seriesDetails, videoDocId)
        if (currentVideoObj_) {
            setCurrentVideoObj(currentVideoObj_.videoObj)
            dispatch(setVideo(currentVideoObj_.videoObj))
        }
        // console.log("currentVideoObj ", currentVideoObj_)    
    }


    const updateCurrentVideoObj = (videoDocId: string) => {
        setVideoChangingId(videoDocId)
        const p = new URLSearchParams()
        if (seriesId) p.set("series", seriesId)
        p.set("video", videoDocId)
        if (isWelcomeSeries) p.set("ws", "true")
        if (isSubscribedSeries) p.set("subscription", "true")
        navigate({ pathname: location.pathname, search: p.toString() }, { state: location.state })
        setVideoId(videoDocId)

        const currentVideoObj_ = findVideoById(seriesDetails, videoDocId)
        if (currentVideoObj_) {
            if (window.innerWidth < maxScreenWidthForDesktop) {
                setCurrentVideoObj(currentVideoObj_.videoObj)
                dispatch(setVideo(currentVideoObj_.videoObj))
            }
        }
    }
    const playNextVideo = () => {
        // console.log(videoId, "current videoId")
        // console.log(seriesDetails)
        const nextVideoObj = findNextVideo(seriesDetails, videoId);
        if (nextVideoObj !== "") {
            // console.log("Next video:", nextVideoObj);
            updateCurrentVideoObj(nextVideoObj._id)
        } 
    }



    // START : util fns
    const findNextVideo = (sections: any[], currentVideoId: any): any => {
        // Find the current video and its section
        let currentSectionIndex = -1;
        let currentVideoIndex = -1;

        // Loop through sections to find current video
        for (let i = 0; i < sections.length; i++) {
            const section = sections[i];
            const videoIndex = section.videos.findIndex((video: any) => video._id === currentVideoId);

            if (videoIndex !== -1) {
                currentSectionIndex = i;
                currentVideoIndex = videoIndex;
                break;
            }
        }

        // If current video not found, return empty string
        if (currentSectionIndex === -1 || currentVideoIndex === -1) {
            return "";
        }

        const currentSection = sections[currentSectionIndex];

        // Check if there's a next video in the same section
        if (currentVideoIndex < currentSection.videos.length - 1) {
            return currentSection.videos[currentVideoIndex + 1];
        }

        // If no next video in current section, check next section
        if (currentSectionIndex < sections.length - 1) {
            const nextSection = sections[currentSectionIndex + 1];
            if (nextSection.videos && nextSection.videos.length > 0) {
                return nextSection.videos[0]; // Return first video of next section
            }
        }

        // No next video found (this is the last video of the last section)
        return "";
    };


    const findVideoById = (data: any, targetId: any) => {
        for (const section of data) {
            const videoObj = section.videos.find((v: { _id: string; }) => v._id === targetId);
            if (videoObj) {
                return { videoObj };
            }
        }
        return null;
    }

    const findFirstVideoInSeries = (data: any) => {
        if (!Array.isArray(data)) return null;
        for (const section of data) {
            const vids = section?.videos;
            if (Array.isArray(vids) && vids.length > 0) return vids[0];
        }
        return null;
    };

    /** Resolve by `video` query when present; otherwise first video in series (dashboard series-only links). */
    const resolveVideoFromSeriesData = (
        data: any,
        targetVideoId: string | null
    ): { videoObj: any } | null => {
        if (!Array.isArray(data) || data.length === 0) return null;
        const t = targetVideoId && String(targetVideoId).trim();
        if (t) {
            const byId = findVideoById(data, t);
            if (byId) return byId;
        }
        const first = findFirstVideoInSeries(data);
        return first ? { videoObj: first } : null;
    };

    // const getSeriesId = () => {
    //     const seriesId = searchParams.get("series");
    //     return seriesId
    // }
    // END : util fns



    return (
        <>
            <WatchMainView
                isLoading={isLoading}
                screenWidth={screenWidth}
                isHydrated={isHydrated}
                currentVideoObj={currentVideoObj}
                seriesNotes={seriesNotes}
                updateCurrentVideoObj={updateCurrentVideoObj}
                videoChangingId={videoChangingId}
                playNextVideo={playNextVideo}
                isWelcomeSeries={isWelcomeSeries}
                seriesId={seriesId}
                isSubscribedSeries={isSubscribedSeries}
                isPGCourseSeries={isPGCourseSeries}
            />
            <Toaster richColors
                position="top-center" />
            {/* <Footer /> */}
            <FloatingSupportButtons />
        </>
    );
}
